<template>
  <div class="pop-up-container">
    <img
      src="/icons/PopUpClose.svg"
      alt=""
      @click="$emit('close')"
      class="close-pop-up"
    />
    <div @scroll.prevent="" id="image-slider" class="slider-container">
      <div class="image-slider">
        <div class="tip" v-for="(image,index) in images" :key="index">
          <img
            :class="['image', selected == index ? 'image-selected' : '']"
            :src="image"
            alt=""
          />
          <div class="text-tip">
            {{ index + 1 }}.
            <span v-html="$t(`online_payment.help.${gateway}.${index}`, {
              menuLink
            })"></span>
          </div>
        </div>
       
      </div>
    </div>
    <div class="guide-img-controls">
      <div @click="ScrollTips('left')" class="arrow">
        <img src="/icons/arrow-left.svg" alt="" />
      </div>
      <div @click="ScrollTips('right')" class="arrow">
        <img src="/icons/arrow-left.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: 0,
      // images: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  props: {
    gateway: String
  },
  methods: {
    ScrollTips(direction) {
      console.log(direction);
      let imageSlider = document.getElementById("image-slider");
      let element = document.getElementsByClassName("tip")[0];
      let style = window.getComputedStyle(element);
      let elWidth =
        element.offsetWidth +
        parseFloat(style.marginLeft) +
        parseFloat(style.marginRight);
      if (direction == "left" && this.selected > 0) this.selected -= 1;
      else if (direction == "right" && this.selected + 1 < this.images.length)
        this.selected += 1;
      imageSlider.scrollLeft = elWidth * this.selected;
    },
  },
  computed: {
    images() {
      const MAX_STEPS_MAP = {
        liqpay: 5,
        wayforpay: 5,
        stripe: 6,
        yookassa: 5
      }

      const max_steps = MAX_STEPS_MAP[this.gateway];

      let arr = [];

      for (let i = 0; i < max_steps; i++) {
        arr.push(`/img/gateways/${this.gateway}_guide_${i+1}.png`);
      }

      return arr;
    },
    menuLink() {
      return this.$store.getters.onlineMenuLink();
    }
  }
};
</script>
<style scoped>
.pop-up-container {
  width: 100%;
  height: 102vh;
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(70, 70, 70, 0.5);
  backdrop-filter: blur(7px);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.close-pop-up {
  width: 2.777vh;
  position: absolute;
  top: 2.222vh;
  right: 2.222vh;
  cursor: pointer;
}
.text-tip {
  font-weight: normal;
  font-size: 2.222vh;
  line-height: 2.555vh;
  text-align: center;
  color: #ededed;
  margin: 1.8888vh 0 1.111vh;
  text-align: center;
  width: 75vw;
  min-height: 7.888vh;
}
.guide-img-controls {
  display: flex;
  position: absolute;
  bottom: 6.888888888888889vh;
  left: calc(50% - 6.666vh);
}
.arrow {
  width: 6.666vh;
  height: 3.555vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1d1d1b;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
}
.arrow img {
  width: 1.111vh;
  height: 2.222vh;
}

.arrow:last-child {
  transform: rotate(180deg);
  border-radius: 4px 0 0 4px;
  border-right: 1px solid #464646;
}
.tip {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
}

.tip:last-child {
  margin-right: 22vh;
}

.slider-container {
  width: 100%;
  overflow-x: auto;
  padding: 0 22vh;
  scroll-behavior: smooth;
}
.image-slider {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  float: left;
}
.image {
  width: 100vh;
  height: 64.777vh;
  object-fit: contain;
  object-position: center;
  border-radius: 10px;
  filter: drop-shadow(0px 2px 10px #000000);
  transition: height 0.5s;
}
.image-selected {
  width: 120vh;
  height: 73.666vh;
}
</style>
